import { SalesOrderStatus } from '../constants/sales-order-status.js';
import { isPromoOnlyOrder } from '../sales-order-lines/is-promo-only-order.js';
import { isSampleOrder } from '../sales-order-lines/is-sample-order.js';
import { isSalesOrderBalancePaid } from './is-sales-order-balance-paid.js';
import { PAYMENT_WRITE_BLOCKED_STATUSES } from './payment-write-blocked-statuses.js';
/**
 * Clear Balance is allowed only with no real AR to collect and an unblocked status. A Delivered Credit Return's open balance is the
 * customer's credit, and clearing it is the deliberate "Waive credit" close; the waive is a reversible BALANCE_CLEAR row.
 */
export function canClearSalesOrderBalance({ items, balanceDue, statusId, isCreditReturn = false, }) {
    // Keep the status check, since the frontend and other non-resolver callers rely on it despite the resolver's duplicate.
    if (PAYMENT_WRITE_BLOCKED_STATUSES.includes(statusId))
        return false;
    if (isCreditReturn && statusId === SalesOrderStatus.DELIVERED)
        return true;
    // null means never computed, not zero, so a never-computed SALE order must not read as clearable.
    if (balanceDue === null)
        return isSampleOrder(items) || isPromoOnlyOrder(items);
    return isSampleOrder(items) || isPromoOnlyOrder(items) || isSalesOrderBalancePaid(balanceDue);
}
//# sourceMappingURL=can-clear-sales-order-balance.js.map